export const IntegrationMappersExpandColumns = {
	model: [
		{
			label: 'Integration Id',
			key: 'key'
		},
		{
			label: 'Integration Label',
			key: 'label'
		},
		{
			label: 'Tracking System',
			key: 'trackingSystem',
			type: 'select',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
				{ label: 'Acuity', value: 'cmpAcuity' },
			],
			onChange: ($event: any, row: any, model: any, integrationData: any, extraData: any) => {

				switch ($event.value) {
					case 'Acuity':
						model[3].options = extraData.acuityOptions;
						break;
					case 'AppScope':
						model[3].options = extraData.appScopeOptions;
						break;
					case 'cmpAcuity':
						model[3].options = extraData.appScopeOptions;
						break;
					default:
						model[3].options = [];
						break;

				}

				if (model[3].options[0]) {
					const selectedValue = model[3].options[0];

					integrationData[row.id] = {
						...row,
						...{
							trackingSystemId: selectedValue.value,
							trackingSystemLabel: selectedValue.label
						}
					};
				}
			}
		},
		{
			label: 'Tracking System Option',
			key: 'trackingSystemId',
			type: 'select',
			options: [],
			onChange: ($event: any, row: any, model: any, integrationData: any, extraData: any, formGroup: any) => {
				let selectedValue = [];

				if (row.trackingSystem === 'Acuity') {
					selectedValue = extraData.acuityOptions.filter((option: any) => option.value === $event.value);
				} else {
					selectedValue = extraData.appScopeOptions.filter((option: any) => option.value === $event.value);
				}

				if (selectedValue.length) {
					integrationData[row.id] = {
						...row,
						...{
							trackingSystemId: selectedValue[0].value,
							trackingSystemLabel: selectedValue[0].label
						}
					};
				}
			},
			getValue: (field: any, row: any) => {
				return row['trackingSystemLabel'];
			}
		},
		{
			label: 'Tracking System Id',
			key: 'trackingSystemId',
			disabled: true
		},
		{
			label: 'Tracking System Label',
			key: 'trackingSystemLabel',
			disabled: true
		}
	],
	callBacks: {
		onRowEditInit: (row: any, model: any, extraData: any) => {
			if (row.trackingSystem === 'Acuity') {
				model[3].options = extraData.acuityOptions;
			} else {
				model[3].options = extraData.appScopeOptions;
			}
		}
	},
	formBuilderConfig: {
		key: {
			DataType: 'String',
			DisplayText: 'Integration Id',
			Name: 'key'
		},
		label: {
			DataType: 'String',
			DisplayText: 'Integration Label',
			Name: 'label'
		},
		trackingSystem: {
			DataType: 'Selector',
			DisplayText: 'Tracking System',
			Name: 'trackingSystem',
			UIControl: 'Dropdown',
			options: [],
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
					model['trackingSystemId'].options = [];

					if($event.value) {
						const trackingSystemOptionsName = $event.value[0].toLowerCase() + $event.value.substring(1);
						model['trackingSystemId'].options = extraData[trackingSystemOptionsName];
					}

					if (formGroup) {
						formGroup.get('trackingSystemId')?.setValue(null);
						formGroup.get('trackingSystemLabel')?.setValue(null);
					}
				}
			}
		},
		trackingSystemId: {
			DataType: 'Selector',
			DisplayText: 'Tracking System Option',
			Name: 'trackingSystemId',
			UIControl: 'Dropdown',
			options: [],
			UIOptions: {
				ShowFilter: true
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
					let selectedValue = [];
					if (formGroup) {
						const trackingSystem = formGroup.get('trackingSystem')?.value;
						if (trackingSystem) {
							const trackingSystemOptionsName = trackingSystem[0].toLowerCase() + trackingSystem.substring(1);
							selectedValue = extraData[trackingSystemOptionsName]?.filter((option: any) => option.value === $event.value);
						}
						if (selectedValue.length) {
							formGroup.get('trackingSystemId')?.setValue(selectedValue[0].value);
							formGroup.get('trackingSystemLabel')?.setValue(selectedValue[0].label);
						}
					}
				}
			}
		},
		trackingSystemLabel: {
			DataType: 'String',
			DisplayText: 'Tracking System Label',
			Name: 'trackingSystemLabel',
			hidden: true
		},
		mapType: {
			DataType: 'String',
			DisplayText: 'Mapper Type',
			Name: 'mapType',
			hidden: true,
			required: false
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}
